import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { IonItemSliding } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { asyncScheduler } from 'rxjs';

import { ListMorePopoverComponent } from '../../../../shared/components/list-more-popover/list-more-popover.component';
import { AnalyticsService } from '../../../../shared/services/analytics.service';
import { PopoverDropdownService } from '../../../../shared/services/popover/popover-dropdown.service';
import { Buttoms, DefaultListOrder } from '../../models/order-list';
import { IProductos, ISummaryPrice } from '../../models/productos';
import { environment } from './../../../../../environments/environment';
import { ILimitsToast } from './../../../../shared/models/ApplicationUser';
import { SummaryPriceDefault } from './../../../../shared/models/Constants';
import { ToastControllerService } from './../../../../shared/services/toast-controller.service';

@Component({
  selector: 'order-cart',
  templateUrl: './order-cart.component.html',
  styleUrls: ['./order-cart.component.scss'],
})
export class OrderCartComponent implements OnInit, OnDestroy {

  @ViewChild('itemSliding', { static: true }) itemSliding: IonItemSliding = {} as IonItemSliding;

  @Input() producto: IProductos = {} as IProductos;
  @Input() drawer = false;
  @Input() summaryPrice: ISummaryPrice = SummaryPriceDefault;
  @Input() LimitMaxCajas = 0;
  @Input() LimitMaxMonto = 0;
  @Input() isMax = false;
  @Input() resetRange = false;
  @Input() warningSelector = false;

  @Output() addProducto = new EventEmitter<{ cartProducto: IProductos, productsSelect: number }>()
  @Output() removeProducto = new EventEmitter<IProductos>()

  public isFactorCl = environment.production;
  public rangeInput: Buttoms = DefaultListOrder.componentContent.range.buttoms;
  public moreProducts: { id: number; name: string; icon?: string }[] = [];
  public colDescrip = window.innerWidth >= 320 && window.innerWidth < 360 ? 4 : 5;
  public colButtoms = window.innerWidth >= 320 && window.innerWidth < 360 ? 4 : 3;

  constructor(
    private analytService: AnalyticsService
    , private translate: TranslateService
    , private popoverS: PopoverDropdownService
    , private toastS: ToastControllerService
  ) { }

  ngOnInit() {
    this.moreProducts = this.translate.instant(`PopoverList.MoreProductStore`);
    const configurationRange: { initial: number; end: number } = this.translate.instant(`RangeSelector.Store`);
    this.rangeInput = { ...this.rangeInput, ...configurationRange };
  }

  ngOnDestroy() {
    this.popoverS.dismissPopover([{ id: 0 }]);
  }

  public comeBack = async (productsSelect: number) => {
    if (!this.isMax) {
      // * Validación de precio maximo
      const totalPrice = this.summaryPrice.total_precio - ((this.producto.productos || 0) * (this.producto.precio || 0));
      const priceSelected = ((this.producto.precio || 0) * productsSelect) + totalPrice;
      if (this.LimitMaxMonto > 0 && priceSelected > this.LimitMaxMonto) {
        await this.toastS.dismissToast();
        const { header, message, color, icon, duration, clase, position }: ILimitsToast = this.translate.instant('Toasts.limits-prices');
        this.toastS.presentToast(message.replace('{{limit}}', this.LimitMaxMonto.toString()), color, icon, duration, clase, position, header);
        this.resetRange = true;
        asyncScheduler.schedule(() => this.resetRange = false, 50);
        return;
      }

      // * Validación de cajas maximo
      const totalCajas = ((this.summaryPrice.FactorCl || 0) - ((this.producto.FactorCl || 0) * (this.producto.productos || 0))) + ((this.producto.FactorCl || 0) * productsSelect);
      if (this.LimitMaxCajas > 0 && totalCajas > this.LimitMaxCajas) {
        await this.toastS.dismissToast();
        const { header, message, color, icon, duration, clase, position }: ILimitsToast = this.translate.instant('Toasts.limits-boxs');
        this.toastS.presentToast(message.replace('{{limit}}', this.LimitMaxCajas.toString()), color, icon, duration, clase, position, header);
        this.resetRange = true;
        asyncScheduler.schedule(() => this.resetRange = false, 50);
        return;
      }
    }

    this.addProducto.emit({ cartProducto: this.producto, productsSelect });
  }

  public onDelete(producto: IProductos) {
    // TODO JAIR: VALIDAR INTERACCION
    this.analytService.fbAnalytics('interacciones', { data_categoria: 'tienda', data_accion: '/Carrito', data_etiqueta: 'borrar_producto' })
    this.removeProducto.emit(producto)
  }

  public maxRange = (prediccion_resurtido: number): Buttoms => ({ ...this.rangeInput, end: prediccion_resurtido > this.rangeInput.end ? prediccion_resurtido : this.rangeInput.end });

  public onMore = async (event: Event, producto: IProductos) => {
    await this.itemSliding.closeOpened();

    const data = await this.popoverS.presentPopover(
      ListMorePopoverComponent,
      {
        list: this.moreProducts
      },
      event,
      'mpe-popover-list-more',
      'md',
      true,
      true,
      false,
      false,
      false
    );

    if (data) {
      switch (data.id) {
        case 1:
          // TODO JAIR: VALIDAR INTERACCION
          this.analytService.fbAnalytics('interacciones', { data_categoria: 'tienda', data_accion: '/Carrito', data_etiqueta: 'borrar_producto' })
          this.removeProducto.emit(producto)
          break;
      }
    }
  }

}
